import React from 'react';
import { createFdIcon } from './createFdIcon';

// Universal utility icons — recognizable first, branded second. Same
// construction spec: 24×24, currentColor, 2px, butt caps, miter joins, angular.

export const SearchIcon = createFdIcon(
  <>
    <circle cx="11" cy="11" r="6" />
    <line x1="15.5" y1="15.5" x2="20" y2="20" />
  </>,
  'SearchIcon'
);

export const FilterIcon = createFdIcon(
  <path d="M4 5 H20 L14 12 V19 L10 17 V12 Z" />,
  'FilterIcon'
);

export const SortIcon = createFdIcon(
  <>
    <line x1="5" y1="7" x2="19" y2="7" />
    <line x1="5" y1="12" x2="15" y2="12" />
    <line x1="5" y1="17" x2="11" y2="17" />
  </>,
  'SortIcon'
);

export const ProfileIcon = createFdIcon(
  <>
    <circle cx="12" cy="8" r="4" />
    <path d="M5 21 V18 L8 15 H16 L19 18 V21" />
  </>,
  'ProfileIcon'
);

export const SettingsIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="3.5" />
    <line x1="12" y1="2" x2="12" y2="5" />
    <line x1="12" y1="19" x2="12" y2="22" />
    <line x1="2" y1="12" x2="5" y2="12" />
    <line x1="19" y1="12" x2="22" y2="12" />
    <line x1="5" y1="5" x2="7" y2="7" />
    <line x1="17" y1="17" x2="19" y2="19" />
    <line x1="19" y1="5" x2="17" y2="7" />
    <line x1="7" y1="17" x2="5" y2="19" />
  </>,
  'SettingsIcon'
);

export const BellIcon = createFdIcon(
  <>
    <path d="M6 17 V11 L9 6 H15 L18 11 V17" />
    <line x1="4" y1="17" x2="20" y2="17" />
    <polyline points="10,19 12,21 14,19" />
  </>,
  'BellIcon'
);

export const EditIcon = createFdIcon(
  <>
    <path d="M4 20 V16 L16 4 L20 8 L8 20 Z" />
    <line x1="13" y1="7" x2="17" y2="11" />
  </>,
  'EditIcon'
);

export const TrashIcon = createFdIcon(
  <>
    <line x1="5" y1="7" x2="19" y2="7" />
    <path d="M9 7 V5 H15 V7" />
    <path d="M6 7 L7 20 H17 L18 7" />
    <line x1="10" y1="10" x2="10" y2="17" />
    <line x1="14" y1="10" x2="14" y2="17" />
  </>,
  'TrashIcon'
);

export const CloseIcon = createFdIcon(
  <>
    <line x1="5" y1="5" x2="19" y2="19" />
    <line x1="19" y1="5" x2="5" y2="19" />
  </>,
  'CloseIcon'
);

export const CheckIcon = createFdIcon(
  <polyline points="4,12 10,18 20,6" />,
  'CheckIcon'
);

export const ChevronDownIcon = createFdIcon(<polyline points="6,9 12,15 18,9" />, 'ChevronDownIcon');
export const ChevronUpIcon = createFdIcon(<polyline points="6,15 12,9 18,15" />, 'ChevronUpIcon');
export const ChevronLeftIcon = createFdIcon(<polyline points="15,6 9,12 15,18" />, 'ChevronLeftIcon');
export const ChevronRightIcon = createFdIcon(<polyline points="9,6 15,12 9,18" />, 'ChevronRightIcon');

export const ArrowLeftIcon = createFdIcon(
  <>
    <line x1="20" y1="12" x2="4" y2="12" />
    <polyline points="10,6 4,12 10,18" />
  </>,
  'ArrowLeftIcon'
);
export const ArrowRightIcon = createFdIcon(
  <>
    <line x1="4" y1="12" x2="20" y2="12" />
    <polyline points="14,6 20,12 14,18" />
  </>,
  'ArrowRightIcon'
);

export const ShareIcon = createFdIcon(
  <>
    <circle cx="6" cy="12" r="2.5" />
    <circle cx="18" cy="6" r="2.5" />
    <circle cx="18" cy="18" r="2.5" />
    <line x1="8.2" y1="11" x2="15.8" y2="7" />
    <line x1="8.2" y1="13" x2="15.8" y2="17" />
  </>,
  'ShareIcon'
);

export const MoreIcon = createFdIcon(
  <>
    <rect x="10.5" y="4" width="3" height="3" />
    <rect x="10.5" y="10.5" width="3" height="3" />
    <rect x="10.5" y="17" width="3" height="3" />
  </>,
  'MoreIcon'
);

export const FavoriteIcon = createFdIcon(
  <path d="M12 20 L4 12 V8 L8 4 L12 8 L16 4 L20 8 V12 Z" />,
  'FavoriteIcon'
);

export const StarIcon = createFdIcon(
  <polygon points="12,3 14.6,9 21,9.5 16,14 17.6,20.5 12,17 6.4,20.5 8,14 3,9.5 9.4,9" />,
  'StarIcon'
);

export const VisibilityIcon = createFdIcon(
  <>
    <path d="M3 12 L7 7 H17 L21 12 L17 17 H7 Z" />
    <circle cx="12" cy="12" r="2.5" />
  </>,
  'VisibilityIcon'
);

export const VisibilityOffIcon = createFdIcon(
  <>
    <path d="M3 12 L7 7 H17 L21 12 L17 17 H7 Z" />
    <circle cx="12" cy="12" r="2.5" />
    <line x1="4" y1="4" x2="20" y2="20" />
  </>,
  'VisibilityOffIcon'
);

export const LocationIcon = createFdIcon(
  <>
    <path d="M12 21 L6 11 A6 6 0 1 1 18 11 Z" />
    <circle cx="12" cy="9" r="2" />
  </>,
  'LocationIcon'
);

export const MessageIcon = createFdIcon(
  <path d="M4 5 H20 V16 H10 L6 20 V16 H4 Z" />,
  'MessageIcon'
);

export const EmailIcon = createFdIcon(
  <>
    <rect x="3" y="6" width="18" height="12" />
    <polyline points="3,6 12,13 21,6" />
  </>,
  'EmailIcon'
);

export const LockIcon = createFdIcon(
  <>
    <rect x="5" y="10" width="14" height="10" />
    <path d="M8 10 V7 L10 5 H14 L16 7 V10" />
  </>,
  'LockIcon'
);

export const RefreshIcon = createFdIcon(
  <>
    <path d="M19 8 A8 8 0 1 0 20 13" />
    <polyline points="20,3 20,8 15,8" />
  </>,
  'RefreshIcon'
);

export const SendIcon = createFdIcon(
  <>
    <path d="M3 12 L21 4 L14 21 L11 13 Z" />
    <line x1="11" y1="13" x2="21" y2="4" />
  </>,
  'SendIcon'
);

export const GroupIcon = createFdIcon(
  <>
    <circle cx="9" cy="8" r="3" />
    <path d="M3 20 V17 L6 14 H12 L15 17 V20" />
    <circle cx="17.5" cy="8" r="2.5" />
    <path d="M15.5 14 H18 L21 17 V20" />
  </>,
  'GroupIcon'
);

export const LogoutIcon = createFdIcon(
  <>
    <path d="M14 4 H5 V20 H14" />
    <polyline points="11,8 15,12 11,16" />
    <line x1="15" y1="12" x2="22" y2="12" />
  </>,
  'LogoutIcon'
);

export const InfoIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="11" x2="12" y2="16" />
    <rect x="11" y="7" width="2" height="2" />
  </>,
  'InfoIcon'
);

export const WarningIcon = createFdIcon(
  <>
    <path d="M12 3 L22 20 H2 Z" />
    <line x1="12" y1="9" x2="12" y2="14" />
    <rect x="11" y="16" width="2" height="2" />
  </>,
  'WarningIcon'
);

export const ErrorIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="7" x2="12" y2="13" />
    <rect x="11" y="15" width="2" height="2" />
  </>,
  'ErrorIcon'
);

export const SuccessIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <polyline points="8,12 11,15 16,9" />
  </>,
  'SuccessIcon'
);

export const AddIcon = createFdIcon(
  <>
    <line x1="12" y1="4" x2="12" y2="20" />
    <line x1="4" y1="12" x2="20" y2="12" />
  </>,
  'AddIcon'
);

export const RemoveIcon = createFdIcon(<line x1="4" y1="12" x2="20" y2="12" />, 'RemoveIcon');

export const DownloadIcon = createFdIcon(
  <>
    <line x1="12" y1="4" x2="12" y2="15" />
    <polyline points="7,10 12,15 17,10" />
    <line x1="4" y1="20" x2="20" y2="20" />
  </>,
  'DownloadIcon'
);

export const CheckCircleIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <polyline points="8,12 11,15 16,9" />
  </>,
  'CheckCircleIcon'
);
